import { Component, OnInit } from '@angular/core';
import { trigger, transition, animate, style } from '@angular/animations';
import { FormControl } from '@angular/forms';
import { Observable } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
import { SectionService } from 'src/app/services/section.service';
import { MetatagService } from 'src/app/services/metatag.service';
import { AlertService } from 'src/app/services/alert.service';

@Component({
  selector: 'app-asociate',
  templateUrl: './asociate.component.html',
  styleUrls: ['./asociate.component.scss'],
  animations: [
    trigger('cardsAnimation', [
      transition(':enter', [
        style({ opacity: 0, transform: 'translateY(20px)' }),
        animate('0.3s ease', style({ opacity: 1, transform: 'translateY(0px)' }))
      ])
    ])
  ]
})
export class AsociateComponent implements OnInit {

  recaptcha: any[];
  myControl = new FormControl();

  options: string[] = [
    'Proceso de Compra',
    '¿Qué tan seguro es el proceso de pago?',
    'Pregunta 3',
    'Pregunta 4',
    'Pregunta 5',
    'Pregunta 6',
    'Pregunta 7',
    'Pregunta 8',
    'Pregunta 9',
    'Pregunta 10'
  ];

  filteredOptions: Observable<string[]>;

  sectionActive = 0;
  isLoading = true;
  section: any;
  boxes: any[] = [];
  boxActive = 0;

  contactName = '';
  contactEmail = '';
  contactMessage = '';
  captchaResolved = false;

  constructor(
    protected sectionService: SectionService,
    protected metatagService: MetatagService,
    protected alertService: AlertService
  ) {}

  ngOnInit() {
    this.metatagService.configSlug('help');
    this.loadData();
    this.filteredOptions = this.myControl.valueChanges
      .pipe(
        startWith(''),
        map(value => this._filter(value))
      );
  }

  clickBox(box) {
    this.boxActive = box.id;
  }

  loadData() {
    this.sectionService.fetchHelpSection().toPromise().then(data => {
      this.isLoading = false;
      if (!data.success) {
        return;
      }
      this.section = data.response.section;
      this.boxes = data.response.box;
    });
  }

  onClickContact() {
    if (this.contactEmail === '' || this.contactMessage === '' || this.contactName === '') {
      this.alertService.showError('Error', 'Debe completar todos los campos de contacto');
      return;
    }
    if (!this.validateEmail(this.contactEmail)) {
      this.alertService.showError('Error', 'Debe ingresar un email válido');
      return;
    }
    this.sectionService.contactHelp(this.contactName, this.contactEmail, this.contactMessage)
      .toPromise()
      .then(() => {
        this.contactName = '';
        this.contactEmail = '';
        this.contactMessage = '';
        this.alertService.showSuccess('Contacto!', 'Muchas gracias por ponerse en contacto, en las próximas horas le estaremos contestando.');
      });
  }

  private _filter(value: string): string[] {
    const filterValue = value.toLowerCase();
    return this.options.filter(option => option.toLowerCase().includes(filterValue));
  }

  validateEmail(email: string): boolean {
    const re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(email);
  }

  resolved(captchaResponse: any[]) {
    this.captchaResolved = true;
  }
}
